import React from "react";
import { Nav, NavItem } from "reactstrap";
import "./SideBar.css";
import { DocumentViewList, DocumentFilterList, DocumentModuleFilterList } from "components/menu/Labels";
import { IDocumentFilter, IDocumentModule, IDocumentView, isTrue } from "../../ui/DocumentRules";
import { useIsBackOfHouse } from 'hooks/useRoles';
import { RailDocument } from "../../../shared/models/api/models";
import { getUserExistingRulebookMode } from "../../../shared/store/applicationState";
import { useNavigate } from "react-router-dom";

interface ISidebarProps {
    activeView: IDocumentView | null,
    setActiveView: (view: IDocumentView | null) => void,
    activeFilter: IDocumentFilter | null,
    setActiveFilter: (filter: IDocumentFilter | null) => void,
    activeSubFilter: IDocumentFilter | null,
    setActiveSubFilter: (filter: IDocumentFilter | null) => void,
    selectedModuleFilter: IDocumentModule | null,
    setSelectedModuleFilter: (module: IDocumentModule | null) => void,
    documentCount: number
}

const Sidebar = (props: ISidebarProps) => {
    var isBackOfHouse = useIsBackOfHouse();
    const navigate = useNavigate();

    const navigateToDocument = (doc: RailDocument) => {
        let mode = getUserExistingRulebookMode();
        if (mode == 'cbtc') {
            mode = 'mbs';
        }
        navigate(`/pdf/view/${mode}/${doc.id}`);
    }

    return (<div className="sidebar document-list-sidebar">
        <div className="view-list">
            <div className="current-view-label">Current view:</div>
            <DocumentViewList activeView={props.activeView} setActiveView={props.setActiveView} />
        </div>
        <div className="filter-list">
            {props.activeView && props.activeView.filters &&
                <>
                    <div className="document-filter-list-heading">
                        {props.activeView?.filterTitle ?? "Contents"}
                    </div>
                    <DocumentFilterList
                        view={props.activeView}
                        activeFilter={props.activeFilter}
                        setActiveFilter={props.setActiveFilter}
                        activeSubFilter={props.activeSubFilter}
                        setActiveSubFilter={props.setActiveSubFilter}
                        documentCount={props.documentCount ?? 0}
                        onDocumentClick={navigateToDocument}
                    />
                </>
            }
        </div>
        <div className="module-filter">
            {props.activeView?.rules && isTrue(props.activeView.rules.canFilterByModule, isBackOfHouse) &&
                <DocumentModuleFilterList
                    title={props.activeView?.filterTitle || "Contents"}
                    canSelectAll={true}
                    selectedModule={props.selectedModuleFilter}
                    setSelectedModule={props.setSelectedModuleFilter} />
            }
        </div>
    </div>);
};

export default Sidebar